import React from 'react';
import MobileHero, { MobileHeroProps } from 'src/components/Hero/MobileHero';

type GamificationTopbarProps = Omit<MobileHeroProps, 'compact' | 'variant'>;

const GamificationTopbar: React.FC<GamificationTopbarProps> = (props) => (
  <div className="relative z-20 shrink-0">
    <MobileHero {...props} variant="home" compact={true} />
  </div>
);

export default GamificationTopbar;
